import { StyleSheet, TouchableOpacity} from "react-native";
import React, { Children } from "react";
import { ArrowRight, CircleAlert, Cog } from "lucide-react-native";
import { Box, Text } from "components/ui";
import { Link, router} from "expo-router";

interface InfoPanelProps {
	icon: React.ReactNode;
	description: string;
	hasAlert?: boolean;
	value: number;
	link?: string;
	params?: any;
}

const InfoPanel = (props: InfoPanelProps) => {

	const LinkSection = ({children, link, params }: { children: React.ReactNode; link?: string; params: any;}) => {
		const handleClick = () => {
			if (link) {
				router.push({
					pathname: link,
					params: params
				});
			}
		};

		if (link) {
			return (
				<TouchableOpacity onPress={handleClick}>
					{children}
				</TouchableOpacity>
			);
		}

		return <>{children}</>;
	};
	
	

	return (
		<Box p={16} borderWidth={1} position="relative" flexDirection="row" alignItems="center" bg={props.hasAlert ? "#fef2f2" : "transparent"} borderColor={props.hasAlert ? "#fef2f2" : "$neutral100"} mb={8} borderRadius={8}>
			{props.hasAlert && (
				<Box position="absolute" right={-8} top={-8}>
					<CircleAlert size={20} color="red" />
				</Box>
			)}

			<Box mr={12}>{props.icon}</Box>
			<LinkSection link={props.link} params={props.params}>
				<Box flex={1} flexDirection="row" justifyContent="space-between" alignItems="center">
					<Box flex={1} flexDirection="row" alignItems="center">
						<Text fontSize={26} fontWeight={"bold"} color="black" mr={8}>
							{props.value}
						</Text>
						<Text paddingHorizontal={6} fontSize={16} color="black">
							{props.description}
						</Text>
					</Box>

					{(props.link && <ArrowRight size={20} color="black" />)}
				</Box>
			</LinkSection>
		</Box>
	);
};

export default InfoPanel;
